import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ContentEditable from '../content_editable';
import sanitizeContentEditableHtml from '../../helpers/sanitize_content_editable_html';
import { selectCellContent } from '../../helpers/table_dom_helper';

class TableCell extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    defaultHtml: PropTypes.string.isRequired,
    editable: PropTypes.bool,
    eventData: PropTypes.any,
    inSelectedColumn: PropTypes.bool,
    inSelectedRow: PropTypes.bool,
    override: PropTypes.string,
    sanitize: PropTypes.bool,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
    style: PropTypes.object,
    tagName: PropTypes.string.isRequired,

    onBlur: PropTypes.func.isRequired,
    onContentEditStart: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onOverrideChange: PropTypes.func.isRequired,
    onOverrideReset: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  }

  handleDoubleClick = () => {
    if (!this.props.selectable) {
      return;
    }

    // Need to wait for React to enable the contenteditable before selecting, so pass a callback
    // through for the appropriate component's setState call
    this.props.onContentEditStart(() => selectCellContent(this));
  }

  handleOverrideChange = (html) => {
    this.props.onOverrideChange(html, this.props.eventData);
  }

  handleOverrideReset = () => {
    this.props.onOverrideReset(this.props.eventData);
  }

  handleSelect = () => {
    if (this.props.selectable) {
      this.props.onSelect(this.props.eventData);
    }
  }

  render() {
    const { inSelectedColumn, inSelectedRow, selected } = this.props;

    const className = classNames(this.props.className, {
      'in-selected-column': inSelectedColumn,
      'in-selected-row': inSelectedRow,
      selectable: this.props.selectable,
      selected
    });

    return (
      <ContentEditable
        className={className}
        defaultHtml={this.props.defaultHtml}
        disabled={this.props.selectable}
        override={this.props.override}
        renderHeader={this.renderHeader}
        sanitizer={this.props.sanitize ? sanitizeContentEditableHtml : null}
        wrapperStyle={this.props.style}
        wrapperTagName={this.props.tagName}
        onBlur={this.props.onBlur}
        onClick={this.handleSelect}
        onDoubleClick={this.handleDoubleClick}
        onFocus={this.props.onFocus}
        onOverrideChange={this.handleOverrideChange}
        onOverrideReset={this.handleOverrideReset}
      />
    );
  }

  renderHeader() {
    return null;
  }
}

export default TableCell;
